import { Button, Tooltip, Typography } from '@mui/material';
import React from 'react';

export default function GroupActionButton({
    title,
    onClick,
    icon = undefined,
    enabled = true,
    tooltipTitle = undefined,
}: {
    title: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    icon?: React.ReactNode;
    enabled?: boolean;
    tooltipTitle?: string;
}): React.ReactElement {
    return (
        <Tooltip title={enabled ? '' : tooltipTitle}>
            <span>
                <Button
                    variant="outlined"
                    sx={{ height: '26px' }}
                    startIcon={icon}
                    onClick={onClick}
                    disabled={!enabled}
                >
                    <Typography variant="body1SemiBold" color="inherit">
                        {title}
                    </Typography>
                </Button>
            </span>
        </Tooltip>
    );
}
